import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { dashboardApi, BLOKKADES_KEY, DASHBOARD_KEY } from '../../services/professionalDashboardApi';
import { WERKPLEK_SIGNALEN_KEY } from '../ProfessionalDashboardSchil';

/**
 * "Opdrachtgever niet meer tonen" (blacklist, migratie 188): na bevestiging
 * verdwijnen diens opdrachten uit marktplaats, Job-Radar en signalen.
 */
export function useBlokkeerOpdrachtgever() {
  const { t } = useTranslation('professionalDashboard');
  const queryClient = useQueryClient();
  const mutatie = useMutation({
    mutationFn: (v: { employerId: string; naam: string }) => dashboardApi.blokkeer(v.employerId),
    onSuccess: (lijst, v) => {
      queryClient.setQueryData(BLOKKADES_KEY, lijst);
      queryClient.invalidateQueries({ queryKey: ['professional-werkplek-opdrachten'] });
      queryClient.invalidateQueries({ queryKey: DASHBOARD_KEY });
      queryClient.invalidateQueries({ queryKey: WERKPLEK_SIGNALEN_KEY });
      toast.success(t('blacklist.verborgen', { naam: v.naam }));
    },
    onError: () => toast.error(t('schakelbord.fout')),
  });
  return {
    bezig: mutatie.isPending,
    blokkeer: (employerId: string, naam: string | null) => {
      const getoond = naam || t('blacklist.dezeOpdrachtgever');
      if (window.confirm(t('blacklist.verbergVraag', { naam: getoond }))) mutatie.mutate({ employerId, naam: getoond });
    },
  };
}
